import { useState } from 'react'
import ThemeMaker from '../../components/thememaker'

const DEFAULT_VALUE = 5

const configOptions = [
    { value: 'default', label: `Default (${DEFAULT_VALUE})` },
    { value: 'custom', label: 'Custom' },
]

const Configuration = () => {
    const [selected, setSelected] = useState('')
    const [customValue, setCustomValue] = useState('')
    const [loading, setLoading] = useState(false)
    const [message, setMessage] = useState(null)

    const handleSelect = (e) => {
        setSelected(e.target.value)
        setCustomValue('')
        setMessage(null)
    }

    const handleSubmit = async () => {
        setMessage(null)

        let payload
        if (selected === 'default') {
            payload = { type: 'default', value: DEFAULT_VALUE }
        } else if (selected === 'custom') {
            const num = Number(customValue)
            if (customValue === '' || Number.isNaN(num) || num <= 0) {
                setMessage({ type: 'error', text: 'Please enter a valid number greater than 0.' })
                return
            }
            payload = { type: 'custom', value: num }
        } else {
            setMessage({ type: 'error', text: 'Please select a configuration.' })
            return
        }

        try {
            setLoading(true)
            const res = await fetch('/api/configuration', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload),
            })
            if (!res.ok) throw new Error('Request failed')
            setMessage({ type: 'success', text: 'Configuration saved successfully.' })
        } catch (err) {
            setMessage({ type: 'error', text: 'Could not save configuration. Please try again.' })
        } finally {
            setLoading(false)
        }
    }

    return (
        <ThemeMaker>
            <div className="container-fluid" style={{ minHeight: '80vh', padding: '20px' }}>
                <h2 style={{ fontWeight: 400, color: '#555', marginBottom: '20px' }}>
                    Configuration
                </h2>

                <div
                    style={{
                        background: '#fff',
                        borderRadius: '6px',
                        borderLeft: '4px solid #4e73df',
                        boxShadow: '0 2px 10px rgba(0,0,0,0.08)',
                        padding: '24px',
                    }}
                >
                    <div
                        style={{
                            fontSize: '18px',
                            fontWeight: 600,
                            color: '#1a1a1a',
                            marginBottom: '14px',
                        }}
                    >
                        Select Configuration
                    </div>

                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            gap: '16px',
                            flexWrap: 'wrap',
                        }}
                    >
                        <div
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '12px',
                                flexWrap: 'wrap',
                                flex: 1,
                            }}
                        >
                            <select
                                value={selected}
                                onChange={handleSelect}
                                style={{
                                    width: '100%',
                                    maxWidth: '360px',
                                    padding: '8px 16px',
                                    fontSize: '14px',
                                    color: '#333',
                                    background: '#eef0f3',
                                    border: 'none',
                                    borderRadius: '20px',
                                    outline: 'none',
                                    cursor: 'pointer',
                                }}
                            >
                                <option value="">-- Select --</option>
                                {configOptions.map((opt) => (
                                    <option key={opt.value} value={opt.value}>
                                        {opt.label}
                                    </option>
                                ))}
                            </select>

                            {selected === 'custom' && (
                                <input
                                    type="number"
                                    min="1"
                                    value={customValue}
                                    onChange={(e) => setCustomValue(e.target.value)}
                                    placeholder="Enter number"
                                    style={{
                                        width: '100%',
                                        maxWidth: '240px',
                                        padding: '8px 16px',
                                        fontSize: '14px',
                                        color: '#333',
                                        background: '#eef0f3',
                                        border: 'none',
                                        borderRadius: '20px',
                                        outline: 'none',
                                    }}
                                />
                            )}
                        </div>

                        {selected && (
                            <button
                                onClick={handleSubmit}
                                disabled={loading}
                                style={{
                                    padding: '8px 28px',
                                    fontSize: '14px',
                                    fontWeight: 600,
                                    color: '#fff',
                                    background: loading ? '#9fb0ea' : '#4e73df',
                                    border: 'none',
                                    borderRadius: '20px',
                                    cursor: loading ? 'not-allowed' : 'pointer',
                                }}
                            >
                                {loading ? 'Submitting...' : 'Submit'}
                            </button>
                        )}
                    </div>

                    {message && (
                        <div
                            style={{
                                marginTop: '14px',
                                fontSize: '14px',
                                color: message.type === 'success' ? '#1a7f37' : '#d93025',
                            }}
                        >
                            {message.text}
                        </div>
                    )}
                </div>
            </div>
        </ThemeMaker>
    )
}

export default Configuration